<script setup lang="ts">
import { computed } from "vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

import SVGWrapper from "./utils/SVGWrapper.vue";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);

const strokeClass = computed((): string => `stroke-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 24 24">
    <path
      d="M0.777832 20.4598C0.777832 20.7569 1.02338 21 1.3235 21C1.62362 21 1.86917 20.7569 1.86917 20.4598C1.86917 17.1184 4.09824 14.1093 7.30405 13.0802C8.04343 13.4124 8.85921 13.6042 9.7241 13.6042C10.589 13.6042 11.4129 13.4124 12.1523 13.0748C15.3527 14.0904 17.579 17.1022 17.579 20.4571C17.579 20.7542 17.8246 20.9973 18.1247 20.9973C18.4248 20.9973 18.6704 20.7542 18.6704 20.4571C18.6704 16.9374 16.5177 13.7528 13.3282 12.3644C14.6979 11.3001 15.5819 9.6524 15.5819 7.7994C15.5846 4.60392 12.9545 2 9.7241 2C6.49373 2 3.8636 4.60392 3.8636 7.8021C3.8636 9.65781 4.75304 11.3109 6.12813 12.3725C2.93323 13.769 0.777832 16.951 0.777832 20.4598ZM4.95494 7.8021C4.95494 5.19818 7.09396 3.08047 9.7241 3.08047C12.3542 3.08047 14.4933 5.19818 14.4933 7.8021C14.4933 10.406 12.3542 12.5237 9.7241 12.5237C7.09396 12.5237 4.95494 10.406 4.95494 7.8021Z"
      :class="colorClass"
    />
    <path
      d="M23.2322 10.8733H20.7766V8.44227C20.7766 8.14514 20.5311 7.90204 20.231 7.90204C19.9309 7.90204 19.6853 8.14514 19.6853 8.44227V10.8733H16.957C16.6568 10.8733 16.4113 11.1164 16.4113 11.4136C16.4113 11.7107 16.6568 11.9538 16.957 11.9538H19.6853V14.3848C19.6853 14.682 19.9309 14.9251 20.231 14.9251C20.5311 14.9251 20.7766 14.682 20.7766 14.3848V11.9538H23.2322C23.5323 11.9538 23.7778 11.7107 23.7778 11.4136C23.7778 11.1164 23.5323 10.8733 23.2322 10.8733Z"
      :class="colorClass"
    />
    <path
      d="M0.777832 20.4598C0.777832 20.7569 1.02338 21 1.3235 21C1.62362 21 1.86917 20.7569 1.86917 20.4598C1.86917 17.1184 4.09824 14.1093 7.30405 13.0802C8.04343 13.4124 8.85921 13.6042 9.7241 13.6042C10.589 13.6042 11.4129 13.4124 12.1523 13.0748C15.3527 14.0904 17.579 17.1022 17.579 20.4571C17.579 20.7542 17.8246 20.9973 18.1247 20.9973C18.4248 20.9973 18.6704 20.7542 18.6704 20.4571C18.6704 16.9374 16.5177 13.7528 13.3282 12.3644C14.6979 11.3001 15.5819 9.6524 15.5819 7.7994C15.5846 4.60392 12.9545 2 9.7241 2C6.49373 2 3.8636 4.60392 3.8636 7.8021C3.8636 9.65781 4.75304 11.3109 6.12813 12.3725C2.93323 13.769 0.777832 16.951 0.777832 20.4598ZM4.95494 7.8021C4.95494 5.19818 7.09396 3.08047 9.7241 3.08047C12.3542 3.08047 14.4933 5.19818 14.4933 7.8021C14.4933 10.406 12.3542 12.5237 9.7241 12.5237C7.09396 12.5237 4.95494 10.406 4.95494 7.8021Z"
      :class="strokeClass"
      stroke-width="0.3"
    />
    <path
      d="M23.2322 10.8733H20.7766V8.44227C20.7766 8.14514 20.5311 7.90204 20.231 7.90204C19.9309 7.90204 19.6853 8.14514 19.6853 8.44227V10.8733H16.957C16.6568 10.8733 16.4113 11.1164 16.4113 11.4136C16.4113 11.7107 16.6568 11.9538 16.957 11.9538H19.6853V14.3848C19.6853 14.682 19.9309 14.9251 20.231 14.9251C20.5311 14.9251 20.7766 14.682 20.7766 14.3848V11.9538H23.2322C23.5323 11.9538 23.7778 11.7107 23.7778 11.4136C23.7778 11.1164 23.5323 10.8733 23.2322 10.8733Z"
      :class="strokeClass"
      stroke-width="0.3"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
